import { css, styled } from '@mui/material';

import DataTableSkeleton from '../DataTableSkeleton/DataTableSkeleton';
import PageHeaderSkeleton from '../PageHeaderSkeleton/PageHeaderSkeleton';
import { listPageSkeletonClasses } from './theme';

import type { ListPageSkeletonOwnerState, ListPageSkeletonProps } from './types';

export default function ListPageSkeleton(props: ListPageSkeletonProps) {
  const { dataTableProps, pageHeaderProps, showActionBar = true, ...others } = props;

  const ownerState: ListPageSkeletonOwnerState = {
    ...props,
    showActionBar,
  };

  return (
    <ListPageSkeletonRoot {...others} ownerState={ownerState}>
      <ListPageSkeletonHeader showMainAction {...pageHeaderProps} ownerState={ownerState} />
      <ListPageSkeletonDataTable showSideMargin {...dataTableProps} ownerState={ownerState} />
    </ListPageSkeletonRoot>
  );
}

const ListPageSkeletonRoot = styled('div', {
  target: listPageSkeletonClasses.root,
})<{ ownerState: ListPageSkeletonOwnerState }>(
  () => css`
    width: 100%;
  `,
);

const ListPageSkeletonHeader = styled(PageHeaderSkeleton, {
  target: listPageSkeletonClasses.header,
})<{ ownerState: ListPageSkeletonOwnerState }>(
  () => css`
    margin: 16px 32px;
  `,
);

const ListPageSkeletonDataTable = styled(DataTableSkeleton, {
  target: listPageSkeletonClasses.dataTable,
})<{ ownerState: ListPageSkeletonOwnerState }>(() => css``);
